import React, { useEffect, useRef, useState } from 'react';
import { Button, Drawer, Textarea } from 'tdesign-react';
import type { TextareaProps } from 'tdesign-react/lib/textarea';

import styles from './index.module.less';

export const JsonTextareaComponent: React.FC<
{
  getFieldDecorator: any;
  onChange: (key: any) => void;
  value: any;
  btnContext: string;
  onBtnClick: (value: string[]) => void;
  valueShow?: string;
  valueType?: 'string' | 'json';
} & TextareaProps
> = ({ valueShow = 'json', valueType = 'string', ...props }) => {
  const [visible, setVisible] = useState(false);

  const [compValue, setCompValue] = useState<string>('');
  const [status, setStatus] = useState<'default' | 'error'>('default');

  const handleChangeComplete = (value: string) => {
    let tmpValue = `${value}`;
    try {
      const valueStr = value.replace(/\n/gi, '');
      const jsonValue = JSON.parse(valueStr);
      tmpValue = valueType === 'json' ? jsonValue : valueStr;
      props.onChange(valueStr);
      setStatus('default');
    } catch (e) {
      setStatus('error');
    }
    setCompValue(`${value}`);
    // formatJson(`${value}`);
    props.onChange(tmpValue);
  };

  const formatJson = (value: string) => {
    if (valueShow !== 'json') {
      setCompValue(value);
      return;
    }

    if (typeof value === 'string') {
      let tmpValue = value;
      try {
        const jsonObj = JSON.parse(tmpValue);
        tmpValue = JSON.stringify(jsonObj, null, 4);
      } catch {}
      setCompValue(tmpValue);
      return;
    }
    if (valueType === 'json') {
      const tmpValue = JSON.stringify(value, null, 4);
      setCompValue(tmpValue);
      return;
    }
  };

  const onceRef = useRef<boolean>(false);
  useEffect(() => {
    if (!props.value) {
      setCompValue('');
      return;
    }
    if (onceRef.current) {
      return;
    }
    onceRef.current = true;
    formatJson(props.value);
  }, [props.value]);

  const triggleClose = () => {
    setVisible(!visible);
  };

  return (
    <>
      <Textarea
        status={status}
        {...props}
        value={compValue}
        onChange={(val) => {
          handleChangeComplete(val);
        }}
      />
      <Button
        theme="default"
        variant="text"
        size="small"
        onClick={() => {
          formatJson(props.value);
        }}
      >
        格式化
      </Button>

      <Button theme="default" variant="text" size="small" onClick={triggleClose}>
        展开
      </Button>

      <Drawer size={'600px'} visible={visible} onClose={triggleClose} footer={false} destroyOnClose>
        <Textarea
          status={status}
          {...props}
          value={compValue}
          onChange={(val) => {
            handleChangeComplete(val);
          }}
          className={styles['custom-textarea']}
          autosize={{ minRows: 10 }}
        />
      </Drawer>
    </>
  );
};
